import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "user-bill",
  "element-loading-background": "rgba(255,255,255,.3)"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "pagination pb-5"
};
import nodata from "@/assets/img/no-data.png";
import { onMounted, ref } from "vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat } from "@/utils/libs";
import { DocumentCopy } from "@element-plus/icons-vue";
import Clipboard from "clipboard";
export default {
  __name: 'UserOrder',
  setup(__props) {
    const items = ref([]);
    const total = ref(0);
    const page = ref(1);
    const pageSize = ref(12);
    const loading = ref(true);
    onMounted(() => {
      fetchData();
      const clipboard = new Clipboard(".copy-order-no");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });

    // 获取数据
    const fetchData = () => {
      // httpGet("/order/list", { page: page.value, page_size: pageSize.value })
      httpGet("/trade/order/list", {
        page: page.value,
        page_size: pageSize.value
      }).then(res => {
        if (res.list) {
          items.value = res.list;
          total.value = res.total;
          page.value = res.page;
          pageSize.value = res.pageSize;
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [items.value.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "order_no",
            label: "订单号"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.order_no), 1), _createVNode(_component_el_icon, {
              class: "copy-order-no",
              "data-clipboard-text": scope.row.order_no
            }, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 2
            }, 1032, ["data-clipboard-text"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "subject",
            label: "产品名称"
          }), _createVNode(_component_el_table_column, {
            prop: "amount",
            label: "订单金额"
          }), _createVNode(_component_el_table_column, {
            label: "订单算力"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.remark?.power), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "pay_method",
            label: "支付渠道"
          }), _createVNode(_component_el_table_column, {
            prop: "pay_name",
            label: "支付名称"
          }), _createVNode(_component_el_table_column, {
            label: "支付时间"
          }, {
            default: _withCtx(scope => [scope.row['pay_time'] ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dateFormat)(scope.row["pay_time"])), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("未支付")])),
              _: 1
            }))]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无数据"
      }, null, 8, ["image"])), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total,prev, pager, next",
        "current-page": page.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        onCurrentChange: _cache[2] || (_cache[2] = $event => fetchData()),
        style: {
          "--el-pagination-button-bg-color": "rgba(86, 86, 95, 0.2)"
        },
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])])])), [[_directive_loading, loading.value]]);
    };
  }
};